

import { SET_STATUS_VALUE } from '../types';


 //設定瀏覽狀況
export const setStatusValue = value => {
    return {
        type: SET_STATUS_VALUE,
        payload: value
    };
};


// WEBPACK FOOTER //
// ./src/actions/Project/ProjectListAction.js